module.exports = __webpack_public_path__ + "img/background-study-assessment-team.7aec5281.jpg";